import { render, staticRenderFns } from "./CGV.vue?vue&type=template&id=01428e26&"
import script from "./CGV.vue?vue&type=script&lang=js&"
export * from "./CGV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports